import {
  getDNIType,
  getDocumentStatus,
  getIdentityValidationStageName,
  IdentityValidation,
  IdentityValidationId,
} from '@contexts/IdentityValidation/domain';
import { IdentityValidationDto } from '../dtos';

export class IdentityValidationResponseDtoMapper {
  static toIdentityValidationModel(dto: IdentityValidationDto): IdentityValidation {
    const identityDocument =
      dto.documentCode && dto.documentType
        ? {
            code: dto.documentCode,
            type: getDNIType(dto.documentType),
            issueDate: dto.documentIssueDate ? new Date(dto.documentIssueDate) : undefined,
          }
        : undefined;
    const documents = {
      picture: {
        status: getDocumentStatus(dto.picture.status),
      },
      document1: {
        status: getDocumentStatus(dto.identityDocument.status),
      },
      document2: {
        status: getDocumentStatus(dto.identityDocument2.status),
      },
    };

    return new IdentityValidation(
      new IdentityValidationId(dto.id),
      getIdentityValidationStageName(dto.stage),
      documents,
      identityDocument
    );
  }
}
